import { createQueryKeyFactory } from '@/utils/queries'

const familyPicturesQueryKeys = createQueryKeyFactory(['familyPictures'])

export default familyPicturesQueryKeys
